import { ButtonHTMLAttributes } from "react";

export default function SecondaryButton({
    type = "button",
    className = "",
    disabled,
    children,
    invert = false,
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
    invert?: boolean;
    loading?: boolean;
}) {
    return (
        <button
            {...props}
            type={type}
            className={
                `inline-flex text-center justify-center shadow-sm gap-2 items-center rounded-md border border-red4 px-4 py-2 text-xs font-semibold uppercase tracking-widest transition duration-500 ease-in-out focus:outline-none focus:ring-offset-2 disabled:opacity-25 overflow-hidden ${
                    invert
                        ? "enabled:hover:bg-white enabled:hover:text-red4 text-white bg-red4"
                        : "enabled:hover:bg-red4 enabled:hover:text-white text-red4"
                }   ${disabled && "opacity-25"} ` + className
            }
            disabled={disabled}
        >
            {children}
        </button>
    );
}
